import loadable from '@loadable/component';

export const AsyncRecentTravelerActivity = loadable(() =>
    import(
        /* webpackChunkName: "recent-traveler-activity" */
        './RecentTravelerActivity'
    )
);

AsyncRecentTravelerActivity.displayName = 'AsyncRecentTravelerActivity';
